"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreateTriggerOrderType = exports.useGetTPSLByTriggerOrder = exports.getTPSLByTriggerOrder = exports.hasTPSLByTriggerOrder = exports.useFuturesTPSLConfig = exports.useTPSLPairId = exports.useTpSlProviders = exports.TPSLUtils = exports.TPSL_ERROR_INVALID_CURRENT_PRICE = exports.ErrorFiledName = exports.TPSLErrorCode = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const TPSLStore_1 = require("./TPSLStore");
const FutureAPI_1 = require("./../../../../apis/FutureAPI");
const rxjs_1 = require("rxjs");
const types_1 = require("./types");
const TP_SL_FLAG_MAP = {
    [interface_1.FuturePositionSide.LONG]: { tp: 1, sl: -1 },
    [interface_1.FuturePositionSide.SHORT]: { tp: -1, sl: 1 },
};
const TP_SL_TYPE_MAP = {
    [interface_1.FuturePositionSide.LONG]: { tp: interface_1.TriggerType.GREATER_EQUAL, sl: interface_1.TriggerType.LESS_EQUAL },
    [interface_1.FuturePositionSide.SHORT]: { tp: interface_1.TriggerType.LESS_EQUAL, sl: interface_1.TriggerType.GREATER_EQUAL },
};
const ORDER_TP_SL_MODE_MAP = {
    [interface_1.FuturePositionSide.LONG]: { [interface_1.TriggerType.GREATER_EQUAL]: "tp", [interface_1.TriggerType.LESS_EQUAL]: "sl" },
    [interface_1.FuturePositionSide.SHORT]: { [interface_1.TriggerType.GREATER_EQUAL]: "sl", [interface_1.TriggerType.LESS_EQUAL]: "tp" },
};
var TPSLErrorCode;
(function (TPSLErrorCode) {
    /**做多止盈小于当前价格 */
    TPSLErrorCode["LONG_TP_LT_LATEST"] = "LONG_TP_LT_LATEST";
    /**做多止盈小于限价价格 */
    TPSLErrorCode["LONG_TP_LT_LIMIT"] = "LONG_TP_LT_LIMIT";
    /**做多止盈小于标记价格 */
    TPSLErrorCode["LONG_TP_LT_MARK"] = "LONG_TP_LT_MARK";
    /**做多止损大于当前价格 */
    TPSLErrorCode["LONG_SL_GT_LATEST"] = "LONG_SL_GT_LATEST";
    /**做多止损大标记价格 */
    TPSLErrorCode["LONG_SL_GT_MARK"] = "LONG_SL_GT_MARK";
    /**做多止损小于强平价 */
    TPSLErrorCode["LONG_SL_LT_LIQ_PRICE"] = "LONG_SL_LT_LIQ_PRICE";
    /**做空止盈大于当前价格 */
    TPSLErrorCode["SHORT_TP_GT_LATEST"] = "SHORT_TP_GT_LATEST";
    /**做空止盈大于限价价格 */
    TPSLErrorCode["SHORT_TP_GT_LIMIT"] = "SHORT_TP_GT_LIMIT";
    /**做空止盈大于标记价格 */
    TPSLErrorCode["SHORT_TP_GT_MARK"] = "SHORT_TP_GT_MARK";
    /**做空止损小于当前价格 */
    TPSLErrorCode["SHORT_SL_LT_LATEST"] = "SHORT_SL_LT_LATEST";
    /**做空止损小于标记价格 */
    TPSLErrorCode["SHORT_SL_LT_MARK"] = "SHORT_SL_LT_MARK";
    /**做空止损大于强平价 */
    TPSLErrorCode["SHORT_SL_GT_LIQ_PRICE"] = "SHORT_SL_GT_LIQ_PRICE";
    /**设置价格非法 */
    TPSLErrorCode["INVALID_PRICE"] = "INVALID_PRICE";
    /**设置的价格小于0 */
    TPSLErrorCode["INVALID_PRICE_LT_ZERO"] = "INVALID_PRICE_LT_ZERO";
    /**未获取到当前价格 */
    TPSLErrorCode["INVALID_CURRENT_PRICE"] = "INVALID_CURRENT_PRICE";
    /**未获取到标记价格 */
    TPSLErrorCode["INVALID_MARK_PRICE"] = "INVALID_MARK_PRICE";
    /**无效的平仓数量 */
    TPSLErrorCode["INVALID_CLOSE_AMOUNT"] = "INVALID_CLOSE_AMOUNT";
    /**设置的平仓数量大于最大值 */
    TPSLErrorCode["INVALID_CLOSE_AMOUNT_GT_MAX"] = "INVALID_CLOSE_AMOUNT_GT_MAX";
    /**分仓买卖价格区间设置异常 */
    TPSLErrorCode["INVALID_TOP_OR_BOTTOM_PRICE"] = "INVALID_TOP_OR_BOTTOM_PRICE";
    /**多仓，止损需低于区间下限价格，止盈需高于区间上限价格 */
    TPSLErrorCode["LONG_SL_GTE_BOTTOM_PRICE"] = "LONG_SL_GTE_BOTTOM_PRICE";
    /**多仓，止损需低于区间下限价格，止盈需高于区间上限价格 */
    TPSLErrorCode["LONG_TP_LTE_TOP_PRICE"] = "LONG_TP_LTE_TOP_PRICE";
    /**空仓，止损需高于区间上限价格，止盈需低于区间下限价格 */
    TPSLErrorCode["SHORT_SL_LTE_TOP_PRICE"] = "SHORT_SL_LTE_TOP_PRICE";
    /**空仓，止损需高于区间上限价格，止盈需低于区间下限价格 */
    TPSLErrorCode["SHORT_TP_GTE_BOTTOM_PRICE"] = "SHORT_TP_GTE_BOTTOM_PRICE";
    /**止损价格应低于 {price} */
    TPSLErrorCode["LIMIT_LONG_SL_GT_LATEST"] = "LIMIT_LONG_SL_GT_LATEST";
    /**止损价格应高于 {price} */
    TPSLErrorCode["LIMIT_SHORT_SL_LT_LATEST"] = "LIMIT_SHORT_SL_LT_LATEST";
    /**止损价格和强平价的价差过近 */
    TPSLErrorCode["SL_LIQ_OFFSET_LIMIT"] = "SL_LIQ_OFFSET_LIMIT";
    /**非法的触发价格 */
    TPSLErrorCode["INVALID_TRIGGER_LIMIT_PRICE"] = "INVALID_TRIGGER_LIMIT_PRICE";
})(TPSLErrorCode = exports.TPSLErrorCode || (exports.TPSLErrorCode = {}));
/**定义错误信息关联的字段 */
var ErrorFiledName;
(function (ErrorFiledName) {
    /**设置限价止盈止损，订单价格输入框 */
    ErrorFiledName["OrderPriceField"] = "order_price";
    /**设置平仓数量时，对应的输入框 */
    ErrorFiledName["CloseQtyField"] = "close_qty";
    /**设置止盈止损触发价格时，对应的输入框 */
    ErrorFiledName["TriggerPriceField"] = "trigger_price";
})(ErrorFiledName = exports.ErrorFiledName || (exports.ErrorFiledName = {}));
/**未获取到当前价格 */
exports.TPSL_ERROR_INVALID_CURRENT_PRICE = {
    code: TPSLErrorCode.INVALID_CURRENT_PRICE,
};
var TPSLUtils;
(function (TPSLUtils) {
    /**获取止盈止损的方向 */
    function getTPSLFlag(mode, side) {
        var _a;
        return (_a = TP_SL_FLAG_MAP[side]) === null || _a === void 0 ? void 0 : _a[mode];
    }
    TPSLUtils.getTPSLFlag = getTPSLFlag;
    /**
     * 通过Percent计算价格
     * percent = 仓位方向 * 杠杆倍数 *（Price-持仓成本）/ 持仓成本
     * （Price-持仓成本） = (持仓成本 * percent)/(仓位方向 * 杠杆倍数)
     * Price = (持仓成本 * percent)/(仓位方向 * 杠杆倍数) + 持仓成本
     * @param params
     * @returns
     */
    function getTPSLPrice(params) {
        var _a;
        const { percent, side, leverage, avgPrice, mode } = params;
        const flag = (_a = getTPSLFlag(mode, side)) !== null && _a !== void 0 ? _a : 1;
        return new trade_utils_lib_1.SafeDecimal(avgPrice)
            .mul(new trade_utils_lib_1.SafeDecimal(percent).div(100))
            .div(new trade_utils_lib_1.SafeDecimal(leverage).mul(flag))
            .add(new trade_utils_lib_1.SafeDecimal(avgPrice))
            .toString();
    }
    TPSLUtils.getTPSLPrice = getTPSLPrice;
    /**
     * 通过价格获取Percent，注意次百分比已经x100
     * 止盈 percent = 仓位方向 * 杠杆倍数 *（Price-持仓成本）/ 持仓成本
     * @param params
     */
    function getTPSLPercent(params) {
        var _a;
        const { price, side, leverage, avgPrice, mode } = params;
        const flag = (_a = getTPSLFlag(mode, side)) !== null && _a !== void 0 ? _a : 1;
        const avgPriceD = new trade_utils_lib_1.SafeDecimal(avgPrice);
        const priceDecimal = new trade_utils_lib_1.SafeDecimal(price);
        if (priceDecimal.lte(0)) {
            return 0;
        }
        const rate = new trade_utils_lib_1.SafeDecimal(price).sub(avgPriceD).mul(leverage).div(avgPriceD);
        // 做多正值为赚钱，向下取整，显示少赚；
        // 做多负值为赔钱，向上取整，显示多亏；
        // 做空正值为赔钱，向上取整，显示多亏；
        // 做空负值为赚钱，向下取整，显示少赚；
        // 案例 精度为0 不乘以flag
        // 做多止盈正5.5 floor 赚5刀
        // 做多止盈负 5.5 up 赔6刀
        // 做多止损正 5.5 floor 赚6刀
        // 做多止损负 5.5 up 赔5刀
        // 做空止盈正 5.5 up 赔6刀
        // 做空止盈负 5.5 floor 赔5刀
        // 做空止损正 5.5 up 赔6刀
        // 做空止损负 5.5 floor 赚5刀
        const round = (() => {
            if (side === interface_1.FuturePositionSide.SHORT) {
                return rate.gte(0) ? trade_utils_lib_1.SafeDecimal.ROUND_CEIL : trade_utils_lib_1.SafeDecimal.ROUND_FLOOR;
            }
            else {
                return rate.gte(0) ? trade_utils_lib_1.SafeDecimal.ROUND_FLOOR : trade_utils_lib_1.SafeDecimal.ROUND_CEIL;
            }
        })();
        return rate.mul(flag).mul(100).toDP(2, round).toNumber();
    }
    TPSLUtils.getTPSLPercent = getTPSLPercent;
    /**
     * 获取止盈止损的盈亏
     */
    function getTPSLProfit(params) {
        const { price, avgPrice, positionQuantity, closeQty, currencyPrecision } = params;
        const flag = new trade_utils_lib_1.SafeDecimal(positionQuantity).gt(0) ? 1 : -1;
        const qty = closeQty ? new trade_utils_lib_1.SafeDecimal(closeQty).abs().mul(flag) : new trade_utils_lib_1.SafeDecimal(positionQuantity);
        return new trade_utils_lib_1.SafeDecimal(price).sub(new trade_utils_lib_1.SafeDecimal(avgPrice)).mul(qty).toFixed(currencyPrecision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
    }
    TPSLUtils.getTPSLProfit = getTPSLProfit;
    /**传入预计盈亏，计算出触发价格 */
    function getTPSLTriggerPriceWithPnl(params, estPnl) {
        const { avgPrice, positionQuantity, closeQty } = params;
        // 确保符号一致，避免计算出现问题
        const flag = new trade_utils_lib_1.SafeDecimal(positionQuantity).gt(0) ? 1 : -1;
        return new trade_utils_lib_1.SafeDecimal(estPnl)
            .div(closeQty ? new trade_utils_lib_1.SafeDecimal(closeQty).abs().mul(flag) : new trade_utils_lib_1.SafeDecimal(positionQuantity))
            .add(new trade_utils_lib_1.SafeDecimal(avgPrice))
            .toString();
    }
    TPSLUtils.getTPSLTriggerPriceWithPnl = getTPSLTriggerPriceWithPnl;
    /**
     * 校验用户输入的触发价格是否合法
     *
     * 下市价单设置止盈止损时需要同时判断当前价格跟标记价格是否满足需求
     *
     * 下限价单设置止盈止损，只判断是否满足当前价格
     *
     * 在仓位上设置止盈止损时，需要判断是否满足预估强平价的限制
     *
     * 其他场景下根据用户选择的触发价格类型来进行判断(标价价格判断标记价格，最新价格则判断当前价格)
     */
    function checkTriggerPriceError(params) {
        const { triggerPrice, curPrice, markPrice, priceType, scenes, side, mode, liqPrice, compareLiquidPrice, limitPrice, limit, field } = params;
        const isLimitTradeScenes = scenes === TPSLStore_1.TPSLScene.TradeLimit;
        const isMarkPriceType = priceType === interface_1.TriggerPriceType.MARK_PRICE;
        if (!triggerPrice || !new trade_utils_lib_1.SafeDecimal(triggerPrice).isFinite()) {
            // 未输入触发价格，直接返回
            return {
                code: TPSLErrorCode.INVALID_PRICE,
            };
        }
        const latestPriceD = new trade_utils_lib_1.SafeDecimal(curPrice);
        const markPriceD = new trade_utils_lib_1.SafeDecimal(markPrice);
        const liqPriceD = new trade_utils_lib_1.SafeDecimal(liqPrice);
        const limitPriceD = new trade_utils_lib_1.SafeDecimal(limitPrice);
        if (latestPriceD.lte(0)) {
            return exports.TPSL_ERROR_INVALID_CURRENT_PRICE;
        }
        if (!isLimitTradeScenes && isMarkPriceType && markPriceD.lte(0)) {
            // 非限价单下单场景设置止盈止损并且选择标记价格模式时，需要确保存在标记价格
            return {
                code: TPSLErrorCode.INVALID_MARK_PRICE,
            };
        }
        const priceD = new trade_utils_lib_1.SafeDecimal(triggerPrice);
        // 触发价格不能等于0
        if (priceD.eq(0)) {
            return {
                code: TPSLErrorCode.INVALID_PRICE_LT_ZERO,
            };
        }
        if (mode === "sl") {
            if (side === interface_1.FuturePositionSide.LONG) {
                if (priceD.lt(0) || (liqPrice && compareLiquidPrice && priceD.lte(liqPriceD))) {
                    return {
                        code: TPSLErrorCode.LONG_SL_LT_LIQ_PRICE,
                        data: { side, mode, condition: "LT", priceType: "estLiq", price: liqPrice },
                        field,
                    };
                }
            }
            else {
                // 大于强平价格
                if (liqPrice && compareLiquidPrice && priceD.gte(liqPriceD)) {
                    return {
                        code: TPSLErrorCode.SHORT_SL_GT_LIQ_PRICE,
                        data: { side, mode, condition: "GT", priceType: "estLiq", price: liqPrice },
                        field,
                    };
                }
            }
        }
        // 止损，当止损价 < 强平标记价格 * Y%， 不允许设置
        if (mode === "sl" && compareLiquidPrice && limit) {
            const spread = new trade_utils_lib_1.SafeDecimal(priceD).sub(liqPriceD).abs();
            if (spread.div(liqPriceD).lessThanOrEqualTo(limit)) {
                if (side === interface_1.FuturePositionSide.LONG) {
                    return {
                        code: TPSLErrorCode.SL_LIQ_OFFSET_LIMIT,
                        data: {
                            side,
                            mode,
                            condition: "LT",
                            priceType: "estLiq",
                            price: liqPriceD.mul(new trade_utils_lib_1.SafeDecimal(limit).plus(1)).toFixed(),
                        },
                        field,
                    };
                }
                else {
                    return {
                        code: TPSLErrorCode.SL_LIQ_OFFSET_LIMIT,
                        data: {
                            side,
                            mode,
                            condition: "GT",
                            priceType: "estLiq",
                            price: liqPriceD.mul(new trade_utils_lib_1.SafeDecimal(limit).sub(1).abs()).toFixed(),
                        },
                        field,
                    };
                }
            }
        }
        if (side === interface_1.FuturePositionSide.LONG) {
            // 做多 止盈 > 当前价格
            if (mode === "tp") {
                switch (scenes) {
                    case TPSLStore_1.TPSLScene.TradeLimit: {
                        if (priceD.lte(limitPriceD)) {
                            return {
                                code: TPSLErrorCode.LONG_TP_LT_LIMIT,
                                data: { side, mode, condition: "LT", priceType: "limit", price: limitPrice },
                                field,
                            };
                        }
                        break;
                    }
                    case TPSLStore_1.TPSLScene.TradeMarket: {
                        // 如果是标记价格，需要比较最新价格跟标记价格
                        if (isMarkPriceType) {
                            if (priceD.lte(markPriceD)) {
                                return {
                                    code: TPSLErrorCode.LONG_TP_LT_MARK,
                                    data: { side, mode, condition: "LT", priceType: "mark", price: markPrice },
                                    field,
                                };
                            }
                        }
                        // 比较最新价格
                        if (priceD.lte(latestPriceD)) {
                            return {
                                code: TPSLErrorCode.LONG_TP_LT_LATEST,
                                data: { side, mode, condition: "LT", priceType: "latest", price: curPrice },
                                field,
                            };
                        }
                        break;
                    }
                    case TPSLStore_1.TPSLScene.Position: {
                        if (isMarkPriceType) {
                            if (priceD.lte(markPriceD)) {
                                return {
                                    code: TPSLErrorCode.LONG_TP_LT_MARK,
                                    data: { side, mode, condition: "LT", priceType: "mark", price: markPrice },
                                    field,
                                };
                            }
                        }
                        else {
                            if (priceD.lte(latestPriceD)) {
                                return {
                                    code: TPSLErrorCode.LONG_TP_LT_LATEST,
                                    data: { side, mode, condition: "LT", priceType: "latest", price: curPrice },
                                    field,
                                };
                            }
                        }
                        break;
                    }
                }
                return undefined;
            }
            // 止损
            switch (scenes) {
                case TPSLStore_1.TPSLScene.TradeLimit: {
                    const minD = trade_utils_lib_1.SafeDecimal.min(latestPriceD, limitPriceD);
                    if (priceD.gte(minD)) {
                        return {
                            code: TPSLErrorCode.LIMIT_LONG_SL_GT_LATEST,
                            data: { side, mode, condition: "GT", priceType: "latest", price: minD.toFixed() },
                            field,
                        };
                    }
                    break;
                }
                case TPSLStore_1.TPSLScene.TradeMarket: {
                    // 比较最新价格
                    if (isMarkPriceType) {
                        if (priceD.gte(markPriceD)) {
                            return {
                                code: TPSLErrorCode.LONG_SL_GT_MARK,
                                data: { side, mode, condition: "GT", priceType: "mark", price: markPrice },
                                field,
                            };
                        }
                    }
                    // 比较最新价格
                    if (priceD.gte(latestPriceD)) {
                        return {
                            code: TPSLErrorCode.LONG_SL_GT_LATEST,
                            data: { side, mode, condition: "GT", priceType: "latest", price: curPrice },
                            field,
                        };
                    }
                    break;
                }
                case TPSLStore_1.TPSLScene.Position: {
                    // 比较标记价格
                    if (isMarkPriceType) {
                        if (priceD.gte(markPriceD)) {
                            return {
                                code: TPSLErrorCode.LONG_SL_GT_MARK,
                                data: { side, mode, condition: "GT", priceType: "mark", price: markPrice },
                                field,
                            };
                        }
                    }
                    else {
                        // 比较最新价格
                        if (priceD.gte(latestPriceD)) {
                            return {
                                code: TPSLErrorCode.LONG_SL_GT_LATEST,
                                data: { side, mode, condition: "GT", priceType: "latest", price: curPrice },
                                field,
                            };
                        }
                    }
                }
            }
            return undefined;
        }
        else {
            // 做空 止盈
            if (mode === "tp") {
                switch (scenes) {
                    case TPSLStore_1.TPSLScene.TradeLimit: {
                        if (priceD.gte(limitPriceD)) {
                            return {
                                code: TPSLErrorCode.SHORT_TP_GT_LIMIT,
                                data: { side, mode, condition: "GT", priceType: "limit", price: limitPrice },
                                field,
                            };
                        }
                        break;
                    }
                    case TPSLStore_1.TPSLScene.TradeMarket: {
                        if (isMarkPriceType) {
                            if (priceD.gte(markPriceD)) {
                                return {
                                    code: TPSLErrorCode.SHORT_TP_GT_MARK,
                                    data: { side, mode, condition: "GT", priceType: "latest", price: markPrice },
                                    field,
                                };
                            }
                        }
                        if (priceD.gte(latestPriceD)) {
                            return {
                                code: TPSLErrorCode.SHORT_TP_GT_LATEST,
                                data: { side, mode, condition: "GT", priceType: "latest", price: curPrice },
                                field,
                            };
                        }
                        break;
                    }
                    case TPSLStore_1.TPSLScene.Position: {
                        if (isMarkPriceType) {
                            if (priceD.gte(markPriceD)) {
                                return {
                                    code: TPSLErrorCode.SHORT_TP_GT_MARK,
                                    data: { side, mode, condition: "GT", priceType: "latest", price: markPrice },
                                    field,
                                };
                            }
                        }
                        else {
                            if (priceD.gte(latestPriceD)) {
                                return {
                                    code: TPSLErrorCode.SHORT_TP_GT_LATEST,
                                    data: { side, mode, condition: "GT", priceType: "latest", price: curPrice },
                                    field,
                                };
                            }
                        }
                        break;
                    }
                }
                // 触发价格不能小于0
                if (priceD.lt(0)) {
                    return {
                        code: TPSLErrorCode.INVALID_PRICE_LT_ZERO,
                        field,
                    };
                }
                return undefined;
            }
            // 做空止损
            // 小于最新价格
            switch (scenes) {
                case TPSLStore_1.TPSLScene.TradeLimit: {
                    const maxD = trade_utils_lib_1.SafeDecimal.max(latestPriceD, limitPriceD);
                    if (priceD.lte(maxD)) {
                        return {
                            code: TPSLErrorCode.LIMIT_SHORT_SL_LT_LATEST,
                            data: { side, mode, condition: "LT", priceType: "latest", price: maxD.toFixed() },
                            field,
                        };
                    }
                    break;
                }
                case TPSLStore_1.TPSLScene.TradeMarket: {
                    if (isMarkPriceType) {
                        if (priceD.lte(markPriceD)) {
                            return {
                                code: TPSLErrorCode.SHORT_SL_LT_MARK,
                                data: { side, mode, condition: "LT", priceType: "mark", price: markPrice },
                                field,
                            };
                        }
                    }
                    if (priceD.lte(latestPriceD)) {
                        return {
                            code: TPSLErrorCode.SHORT_SL_LT_LATEST,
                            data: { side, mode, condition: "LT", priceType: "latest", price: curPrice },
                            field,
                        };
                    }
                    break;
                }
                case TPSLStore_1.TPSLScene.Position: {
                    if (isMarkPriceType) {
                        if (priceD.lte(markPriceD)) {
                            return {
                                code: TPSLErrorCode.SHORT_SL_LT_MARK,
                                data: { side, mode, condition: "LT", priceType: "mark", price: markPrice },
                                field,
                            };
                        }
                    }
                    else {
                        if (priceD.lte(latestPriceD)) {
                            return {
                                code: TPSLErrorCode.SHORT_SL_LT_LATEST,
                                data: { side, mode, condition: "LT", priceType: "latest", price: curPrice },
                                field,
                            };
                        }
                    }
                    break;
                }
            }
        }
        return undefined;
    }
    TPSLUtils.checkTriggerPriceError = checkTriggerPriceError;
    function getTriggerType(mode, side) {
        var _a;
        return (_a = TP_SL_TYPE_MAP[side]) === null || _a === void 0 ? void 0 : _a[mode];
    }
    TPSLUtils.getTriggerType = getTriggerType;
    function getOrderTPSLMode(order) {
        var _a;
        const { position_side, trigger_type } = order;
        return (_a = ORDER_TP_SL_MODE_MAP[position_side]) === null || _a === void 0 ? void 0 : _a[trigger_type];
    }
    TPSLUtils.getOrderTPSLMode = getOrderTPSLMode;
    function getPercent(position, triggerPrice, mode) {
        const { position_side, leverage, avgPrice } = position;
        return TPSLUtils.getTPSLPercent({ price: triggerPrice || "", side: position_side, leverage, avgPrice, mode });
    }
    TPSLUtils.getPercent = getPercent;
    /**根据触发价格计算价格涨跌幅的时候不需要除杠杆 */
    function getPercent2(position, triggerPrice, mode) {
        const { position_side, avgPrice } = position;
        return TPSLUtils.getTPSLPercent({ price: triggerPrice || "", side: position_side, leverage: "1", avgPrice, mode });
    }
    TPSLUtils.getPercent2 = getPercent2;
    function getTriggerPrice(position, percent, mode) {
        const { position_side, leverage, avgPrice } = position;
        return TPSLUtils.getTPSLPrice({ percent, side: position_side, leverage, avgPrice, mode });
    }
    TPSLUtils.getTriggerPrice = getTriggerPrice;
    /**根据价格涨跌幅计算触发价格的时候不需要除杠杆 */
    function getTriggerPrice2(position, percent, mode) {
        const { position_side, avgPrice } = position;
        return TPSLUtils.getTPSLPrice({ percent, side: position_side, leverage: "1", avgPrice, mode });
    }
    TPSLUtils.getTriggerPrice2 = getTriggerPrice2;
    function getEstPnl(position, triggerPrice, mode) {
        const { position_side, leverage, avgPrice, positionQuantity, closeQty, currencyPrecision = 2 } = position;
        return TPSLUtils.getTPSLProfit({
            price: triggerPrice,
            side: position_side,
            leverage,
            avgPrice,
            positionQuantity,
            mode,
            closeQty,
            currencyPrecision,
        });
    }
    TPSLUtils.getEstPnl = getEstPnl;
    /**过滤掉部分错误信息 */
    function filterError(error) {
        if (error && error.code === TPSLErrorCode.INVALID_PRICE) {
            return undefined;
        }
        return error;
    }
    TPSLUtils.filterError = filterError;
    function formatPercent(percent) {
        return new trade_utils_lib_1.SafeDecimal(percent).toDP(4, trade_utils_lib_1.SafeDecimal.ROUND_DOWN).toNumber();
    }
    TPSLUtils.formatPercent = formatPercent;
    function formatProfitPercent(percent, isIncrease, leverage) {
        return new trade_utils_lib_1.SafeDecimal(percent)
            .abs()
            .mul(isIncrease ? 1 : -1)
            .mul(new trade_utils_lib_1.SafeDecimal(leverage))
            .toNumber();
    }
    TPSLUtils.formatProfitPercent = formatProfitPercent;
    /**根据当前止盈止损的模式，修改盈亏的符号 */
    function roundPnlFlagWithMode(pnl, mode) {
        if (!pnl) {
            return pnl;
        }
        if (mode === "sl" && !pnl.includes("-")) {
            return "-" + pnl;
        }
        return pnl;
    }
    TPSLUtils.roundPnlFlagWithMode = roundPnlFlagWithMode;
    function formatPnl(pnl, precision = 2) {
        return new trade_utils_lib_1.SafeDecimal(pnl).toFixed(precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
    }
    TPSLUtils.formatPnl = formatPnl;
    function formatTriggerPrice(price, precision) {
        return new trade_utils_lib_1.SafeDecimal(price).toFixed(precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
    }
    TPSLUtils.formatTriggerPrice = formatTriggerPrice;
    /**计算最大可平数量 */
    TPSLUtils.getMaxCloseAmount = (symbol) => {
        var _a;
        return new trade_utils_lib_1.SafeDecimal(((_a = symbol === null || symbol === void 0 ? void 0 : symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.max) || Number.MAX_VALUE).toString();
    };
    function generatePairId() {
        return `TPSL_PAIR_${Date.now()}`;
    }
    TPSLUtils.generatePairId = generatePairId;
    function withPositionOrOrder(trigger) {
        const withPositionId = (trigger.trigger_position_id || "").length > 1;
        const withOrderId = (trigger.trigger_order_id || "").length > 1;
        return withPositionId || withOrderId;
    }
    TPSLUtils.withPositionOrOrder = withPositionOrOrder;
    /**判断条件单是否是止盈止损单 */
    function isTPSLOrder(trigger) {
        return withPositionOrOrder(trigger) && [interface_1.TriggerType.GREATER_EQUAL, interface_1.TriggerType.LESS_EQUAL].includes(trigger === null || trigger === void 0 ? void 0 : trigger.trigger_type);
    }
    TPSLUtils.isTPSLOrder = isTPSLOrder;
    /**判断条件单是否是止盈止损单 */
    function isTrackOrder(trigger) {
        return (withPositionOrOrder(trigger) && [interface_1.TriggerType.TRAILING_DOWN_REV, interface_1.TriggerType.TRAILING_UP_BACK].includes(trigger === null || trigger === void 0 ? void 0 : trigger.trigger_type));
    }
    TPSLUtils.isTrackOrder = isTrackOrder;
})(TPSLUtils = exports.TPSLUtils || (exports.TPSLUtils = {}));
/**
 * 基于外部传入的仓位信息来获取对应的provider方法
 * @param position 外部传入的仓位信息，该仓位信息页可能是外部自己构造的
 */
function useTpSlProviders(position) {
    const provideEstPnlWithTriggerPrice = (0, react_1.useCallback)((tp, mode) => TPSLUtils.getEstPnl(position, tp, mode), [position]);
    const providePercentWithTriggerPrice = (0, react_1.useCallback)((tp, mode) => TPSLUtils.getPercent(position, tp, mode), [position]);
    const provideTriggerPriceWithPercent = (0, react_1.useCallback)((percent, mode) => TPSLUtils.getTriggerPrice(position, percent, mode), [position]);
    const provideTriggerPriceWithPricePercent = (0, react_1.useCallback)((percent, mode) => TPSLUtils.getTriggerPrice2(position, percent, mode), [position]);
    const providePricePercentWithTriggerPrice = (0, react_1.useCallback)((tp, mode) => TPSLUtils.getPercent2(position, tp, mode), [position]);
    const provideTriggerPriceWithPnl = (0, react_1.useCallback)((estPnl) => TPSLUtils.getTPSLTriggerPriceWithPnl(position, estPnl), [position]);
    return {
        provideEstPnlWithTriggerPrice,
        providePercentWithTriggerPrice,
        provideTriggerPriceWithPercent,
        provideTriggerPriceWithPnl,
        provideTriggerPriceWithPricePercent,
        providePricePercentWithTriggerPrice,
    };
}
exports.useTpSlProviders = useTpSlProviders;
/**生成止盈止损的pair id */
function useTPSLPairId() {
    return (0, react_1.useMemo)(() => TPSLUtils.generatePairId(), []);
}
exports.useTPSLPairId = useTPSLPairId;
const FuturesTPSLConfigSubject = {
    subject: new rxjs_1.BehaviorSubject(null),
    loading: false,
    subCount: 0,
};
function useFuturesTPSLConfig(symbol) {
    const [config, setConfig] = (0, react_1.useState)(FuturesTPSLConfigSubject.subject.getValue());
    (0, react_1.useEffect)(() => {
        if (!FuturesTPSLConfigSubject.subject.getValue() && !FuturesTPSLConfigSubject.loading) {
            FuturesTPSLConfigSubject.loading = true;
            const qSub = (0, FutureAPI_1.queryFuturesTPSLConfig)().subscribe({
                next: (data) => {
                    FuturesTPSLConfigSubject.loading = false;
                    FuturesTPSLConfigSubject.subject.next(data);
                    qSub.unsubscribe();
                },
                error: (error) => {
                    console.warn(error);
                    FuturesTPSLConfigSubject.loading = false;
                },
            });
        }
        const sub = FuturesTPSLConfigSubject.subject.subscribe({
            next: (data) => {
                if (data) {
                    setConfig(data);
                }
            },
            error: (error) => {
                console.warn(error);
            },
        });
        FuturesTPSLConfigSubject.subCount++;
        return () => {
            sub.unsubscribe();
            FuturesTPSLConfigSubject.subCount--;
            if (FuturesTPSLConfigSubject.subCount === 0) {
                (0, rxjs_1.timer)(60 * 1000).subscribe(() => {
                    if (FuturesTPSLConfigSubject.subject.getValue() !== null) {
                        FuturesTPSLConfigSubject.subject.next(null);
                    }
                });
            }
        };
    }, []);
    return (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f;
        if (!config) {
            return;
        }
        if (!symbol) {
            return;
        }
        const offsetLimit = (_b = (_a = config === null || config === void 0 ? void 0 : config.sl_liqui_offset_limit) === null || _a === void 0 ? void 0 : _a[symbol]) !== null && _b !== void 0 ? _b : (_c = config === null || config === void 0 ? void 0 : config.sl_liqui_offset_limit) === null || _c === void 0 ? void 0 : _c.DEFAULT;
        const warningOffsetLimit = (_e = (_d = config === null || config === void 0 ? void 0 : config.sl_liqui_warning_offset_limit) === null || _d === void 0 ? void 0 : _d[symbol]) !== null && _e !== void 0 ? _e : (_f = config === null || config === void 0 ? void 0 : config.sl_liqui_warning_offset_limit) === null || _f === void 0 ? void 0 : _f.DEFAULT;
        return {
            offsetLimit,
            warningOffsetLimit,
        };
    }, [symbol, config]);
}
exports.useFuturesTPSLConfig = useFuturesTPSLConfig;
function hasTPSLByTriggerOrder(data) {
    return !!(data.triggers && data.triggers.length > 0);
}
exports.hasTPSLByTriggerOrder = hasTPSLByTriggerOrder;
function getTPSLByTriggerOrder(data) {
    let tpOrder = undefined, slOrder = undefined;
    if (hasTPSLByTriggerOrder(data)) {
        data.triggers.forEach((order) => {
            if (TPSLUtils.getOrderTPSLMode(order) === "tp") {
                tpOrder = order;
            }
            else if (TPSLUtils.getOrderTPSLMode(order) === "sl") {
                slOrder = order;
            }
        });
    }
    return {
        tpOrder,
        slOrder,
    };
}
exports.getTPSLByTriggerOrder = getTPSLByTriggerOrder;
function useGetTPSLByTriggerOrder(data) {
    return (0, react_1.useMemo)(() => getTPSLByTriggerOrder(data), [data]);
}
exports.useGetTPSLByTriggerOrder = useGetTPSLByTriggerOrder;
function getCreateTriggerOrderType({ closeMode, checkLimit = false }) {
    if (checkLimit) {
        return interface_1.CustomOrderType.LIMIT;
    }
    if (closeMode === types_1.TPSLCloseMode.CloseAll) {
        return interface_1.CustomOrderType.CLOSE;
    }
    return interface_1.CustomOrderType.MARKET_QTY;
}
exports.getCreateTriggerOrderType = getCreateTriggerOrderType;
